import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  BUSINESS_INFO_ROUTE,
  EXISTING_USER_INVITATION,
  PROFILE_ROUTE,
  VERIFY_ACCOUNT_ROUTE,
} from './constants';

const AccountVerification = lazy(() => import('./pages/AccountVerification'));
const BusinessInfo = lazy(() => import('./pages/BusinessInfo'));
const ExistingUserInvite = lazy(() => import('./pages/ExistingUserInvite'));
const Profile = lazy(() => import('./pages/Profile'));
const Signup = lazy(() => import('./pages/Signup'));

export const TrialsPage = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route element={<Profile />} path={PROFILE_ROUTE} />
        <Route element={<AccountVerification />} path={VERIFY_ACCOUNT_ROUTE} />
        <Route element={<BusinessInfo />} path={BUSINESS_INFO_ROUTE} />
        <Route
          element={<ExistingUserInvite />}
          path={EXISTING_USER_INVITATION}
        />
        <Route element={<Signup />} path="*" />
      </Routes>
    </Suspense>
  );
};

export default TrialsPage;
